import React from "react";
import styled from "styled-components";

const Container = styled.div`
    max-width: 800px;
    margin: 2rem auto;
    padding: 0 1rem;
`;

const CartBox = styled.div`
    background: ${(props) => (props.theme === "light" ? "white" : "#1f2937")};
    border: 1px solid ${(props) => (props.theme === "light" ? "#e5e7eb" : "#374151")};
    border-radius: 0.75rem;
    overflow: hidden;
`;

const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    color: #9ca3af;
`;

const CartItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem;
    border-bottom: 1px solid ${(props) => (props.theme === "light" ? "#f3f4f6" : "#374151")};
`;

const ItemInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

// ★ 썸네일 이미지를 담을 컨테이너 추가
const ThumbnailBox = styled.div`
    width: 60px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    flex-shrink: 0; /*공간이 좁아져도 찌그러지지 않게*/
`;

const RemoveBtn = styled.button`
    background: none;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    font-size: 1.2rem;
    &:hover { color: #ef4444; }
`;

const Summary = styled.div`
    padding: 1.5rem;
    background-color: ${(props) => (props.theme === "light" ? "#f9fafb" : "#111827")};
`;

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: ${(props) => (props.theme === "light" ? "#4b5563" : "#d1d5db")};

    &.total {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #e5e7eb;
        font-size: 1.25rem;
        font-weight: bold;
        color: ${(props) => (props.theme === "light" ? "#111827" : "white")};
    }
`;

const OrderBtn = styled.button`
    width: 100%;
    padding: 1rem;
    margin-top: 1rem;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 0.75rem;
    font-size: 1.125rem;
    font-weight: bold;
    cursor: pointer;
    &:hover { background-color: #1d4ed8; }
`;

function ShippingVerdict({ price, convertPrice }) {
    if (price >= 20000) return <span style={{color:"#28a745", fontSize:"0.8rem", display:"block"}}>무료 배송 적용!</span>;
    return <span style={{color:"#ef4444", fontSize:"0.8rem", display:"block"}}>+ {convertPrice(3000)} (배송비)</span>;
}

function CartPage({ cartItems, removeFromCart, onOrder, convertPrice, theme }) {
    const itemsTotal = cartItems.reduce((acc, item) => acc + item.price, 0);
    const shippingCost = itemsTotal > 0 && itemsTotal < 20000 ? 3000 : 0;
    const finalTotal = itemsTotal + shippingCost;

    if (cartItems.length === 0) {
        return (
            <Container>
                <EmptyState>
                    <div style={{fontSize:"3rem", opacity:0.3}}>🛒</div>
                    <p>장바구니가 비어있습니다.</p>
                </EmptyState>
            </Container>
        );
    }

    return (
        <Container>
            <h2 style={{marginBottom:"1.5rem"}}>장바구니 ({cartItems.length})</h2>
            <CartBox theme={theme}>
                {cartItems.map((item, index) => (
                    <CartItem key={index} theme={theme}>
                        <ItemInfo>
                            {/* ★ 수정된 부분: URL이면 이미지 태그, 아니면 텍스트 출력 */}
                            <ThumbnailBox>
                                {item.cover.startsWith("http") ? (
                                    <img
                                        src={item.cover}
                                        alt={item.title}
                                        style={{width:"100%", height:"100%", objectFit:"cover"}}
                                    />
                                ) : (
                                    item.cover
                                )}
                            </ThumbnailBox>

                            <div>
                                <h4 style={{margin:0}}>{item.title}</h4>
                                <small>{item.author}</small>
                            </div>
                        </ItemInfo>
                        <div style={{display:"flex", alignItems:"center", gap:"1rem"}}>
                            <span style={{fontWeight:"bold"}}>{convertPrice(item.price)}</span>
                            <RemoveBtn onClick={() => removeFromCart(index)}>🗑</RemoveBtn>
                        </div>
                    </CartItem>
                ))}

                <Summary theme={theme}>
                    <Row theme={theme}>
                        <span>상품 금액</span>
                        <span>{convertPrice(itemsTotal)}</span>
                    </Row>
                    <Row theme={theme}>
                        <span>배송비</span>
                        <div style={{textAlign:"right"}}>
                            {shippingCost === 0 ? "0원" : convertPrice(shippingCost)}
                            <ShippingVerdict price={itemsTotal} convertPrice={convertPrice} />
                        </div>
                    </Row>
                    <Row className="total" theme={theme}>
                        <span>총 결제금액</span>
                        <span>{convertPrice(finalTotal)}</span>
                    </Row>
                    <OrderBtn onClick={onOrder}>주문하기</OrderBtn>
                </Summary>
            </CartBox>
        </Container>
    );
}

export default CartPage;